/**
 * Model Viewer Module
 *
 * @version
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.56.0 OAUI-596 Migrate Large Model Viewer into Angular
 * 4.56.0 OAUI-614 Migrate LMV navigation bar into angular
 *
 * @author Jenny Lam <jlam@buildcentrix.com>
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 *
 * @copyright (c) 2023 Build Centrix
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModelViewerRoutingModule } from './model-viewer-routing.module';
import { ViewerComponent } from './components/viewer/viewer.component';
import { ViewerHeaderComponent } from './components/viewer/header/header.component';

import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedModule } from '../../components/shared.module';

@NgModule({
  declarations: [ViewerComponent, ViewerHeaderComponent],
  imports: [CommonModule, ModelViewerRoutingModule, SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModelViewerModule {}
